import { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from "react-router-dom";
import TrashIcon from "../../images/icons/TrashIcon.svg";
import SendPharmacyIcon from "../../images/icons/SendPharmacyIcon.svg";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";
import {
  BtnGroupStyle,
  BtnIconStyle,
  CommonCard,
  ContentStyle,
  DRxInputStyle,
  DRxSelectStyle,
  DRxTheme,
  HtmlTooltip,
  RxChangeRequestedCard,
  ScrollBarStyle,
} from "../../Theme";
import { YSButton } from "../../uikit/YSButton";
import { DialogPopup } from "../../components/DialogPopup";
import { Form, Formik } from "formik";
import ConfirmPopup from "../../components/ConfirmPopup";
import PendingRxChangeTab from "../../components/PendingRxChangeTab";
import DRxInput from "../../uikit/DRxInput";
import DRxSelect from "../../uikit/DRxSelect";
import {
  RemoveRxchangeDetailsById,
  RxChangeApprovedWithChanges,
  RxchangeDetails,
  RxChangeSendToPharmacy,
} from "../../Apis/AuthApiServices";
import YSSnackBar from "../../uikit/YSSnackBar";
import PendingRxChangeAllergyInfo from "./PendingRxChangeAllergyInfo";
import { useDispatch } from "react-redux";
import { loadingTopRibbon } from "../../Redux/Slice/TopRibbonSlice";
import { loadingPharmacyDropDown } from "../../Redux/Slice/PharmacyDropDownSlice";
import { Tooltip } from "@mui/material";
import RxChangePharmacyInfo from "../PharmacyInformation/RxChangePharmacyInfo";
import RxAlertsArrow from "../../images/icons/rxchange_alerts_right_arrow.svg";
import RxPrescribedIcon from "../../images/icons/rx_precribed.svg";
import RxRequestedPharmaNote from "../../images/icons/pharamcy_note_icon.svg";
import RxRequestedIcon from "../../images/icons/rx_requested.svg";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import WarningIcon from "../../images/icons/WarningIcon.svg";
import { prescriptionForms } from "../../constants/RxChangeAlerts/rxChangeAlerts";
import { ExpandableText } from "../../common/ExpandableText";
import { drugTypes } from "../../constants/common/DrugTypes";

export default function PendingRxChangeRequest() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  //const { state }: any = useLocation();
  const doctorId: any = localStorage.getItem("doctorId");
  const clinicId: any = sessionStorage.getItem("clinicId");
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [deleteData, setDeleteData] = useState("");
  const [initialValues, setInitialValues] = useState<any>([]);
  const [medRequestSelectedData, setMedRequestSelectedData] = useState<any>([]);
  const [deleteStateData, setDeleteStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const [selectedRxChange, setSelectedRxChange] = useState<any>(null);
  const [activeRxChangeTabClass, setActiveRxChangeTabClass] = useState(false);
  const [load, setLoad] = useState<boolean[]>([]);
  const handleClickLoad = (index: number): void => {
    setLoad((prevState) => {
      const newLoad = [...prevState];
      newLoad[index] = !newLoad[index];
      return newLoad;
    });
  };

  const handleShowDeletePopupClick = () => {
    setDeletePharmacyPopup(true);
  };
  const handleHideDeletePopupClick = () => {
    setDeletePharmacyPopup(false);
  };
  const [deletePharmacyPopup, setDeletePharmacyPopup] = useState(false);
  const [ApprovedPopup, setApprovedPopup] = useState(false);
  const [MedRequestPopup, setMedRequestPopup] = useState(false);
  const handleShowMedRequestPopupClick = () => {
    setMedRequestPopup(true);
  };
  const handleHideMedRequestPopupClick = () => {
    setMedRequestPopup(false);
  };
  const handleShowApprovedPopupClick = () => {
    setApprovedPopup(true);
  };
  const handleHideApprovedPopupClick = () => {
    setApprovedPopup(false);
    navigate("/pendingrxchange");
  };

  const deleteRowData = async () => {
    try {
      const params = new URLSearchParams();
      params.append("rxChangeIds", deleteData);
      const result = await RemoveRxchangeDetailsById(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        getRxchangeDetails();
        dispatch(loadingTopRibbon());
      } else {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (err: any) {
      setDeleteStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  const getRxchangeDetails = async () => {
    try {
      const patientId = JSON.parse(
        localStorage.getItem("pendingrxchangerequest-data")!
      )?.patientId;
      const doctorId = JSON.parse(
        localStorage.getItem("pendingrxchangerequest-data")!
      )?.doctorId;
      const params = new URLSearchParams();
      params.append("doctorId", doctorId); //state?.rowData?.doctorId);
      params.append("patientId", patientId); //state?.rowData?.patientId);
      params.append("rxchangeId", "");
      const result = await RxchangeDetails(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setData(result?.data?.response);
        setMedRequestSelectedData(
          result?.data?.response?.map(
            (rxchange: any) => rxchange?.medicationRequested[0]
          )
        );
        const initialValues = {
          rows: result?.data?.response?.map((item: any, index: number) => ({
            reasonDenied: "0",
            actionType: "0",
            Notes: "",
            paInformation: "",
            // refills: item?.refills ? parseInt(item.refills) : 0,
          })),
        };
        setInitialValues(initialValues);
      } else {
        setData([]);
      }
      setLoading(false);
    } catch (error) {
      setData([]);
      setLoading(false);
    }
  };
  useEffect(() => {
    getRxchangeDetails();
    setActiveRxChangeTabClass(false);

    return () => {
      localStorage.removeItem("pendingrxchangerequest-data");
    };
  }, []);

  const getRxChangeApprovedWithChanges = async (eachItem: any, index: any) => {
    try {
      handleClickLoad(index);
      const bodyData = {
        personRxChangeId:
          eachItem?.medicationRequested[index]?.medicationRequestID,
        patientId: eachItem?.patientInformation?.patientId,
        refillAction: "Approved with changes",
        prescriberAgentId: localStorage.getItem("doctorId"),
        userDetails: {
          userId: localStorage.getItem("LoginUserID"),
          doctorId: eachItem?.doctorId,
          onBehalfDoctorId: "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
      };

      const result = await RxChangeApprovedWithChanges(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        handleClickLoad(index);
        //localStorage.setItem("patientId", eachItem?.patientId);
        sessionStorage.setItem(
          "rxTabs",
          JSON.stringify([result?.data?.response[0]?.prescriptionForm])
        );
        dispatch(loadingPharmacyDropDown());
        sessionStorage.setItem(
          "rxTabsErrors",
          JSON.stringify(result?.data?.response[0]?.prescriptionErrors)
        );
        sessionStorage.setItem(
          "rxHubOptions",
          JSON.stringify(
            result?.data?.response[0]?.prescriptionForm?.rxhubPBMUniqueIdOptions
          )
        );
        sessionStorage.setItem(
          "rxhubPBMUniqueId",
          result?.data?.response[0]?.prescriptionForm?.rxhubPBMUniqueId
        );
        navigate("/newrxpad");
      } else {
        handleClickLoad(index);
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (error) {
      handleClickLoad(index);
      setDeleteStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Something went wrong!",
          variant: "error",
          open: true,
        };
      });
    }
  };
  const [sendToPharmacyData, setSendToPharmacyData] = useState<any>({});

  const prescriptionToSendPharmacy = async (
    eachItem: any,
    values: any,
    index: any
  ) => {
    if (values?.actionType === "APPROVED_WITH_CHANGE") {
      getRxChangeApprovedWithChanges(eachItem, index);
    } else {
      try {
        handleClickLoad(index);

        const patientId = JSON.parse(
          localStorage.getItem("pendingrxchangerequest-data")!
        )?.patientId;
        const bodyData = {
          doctorId: eachItem?.doctorId,
          patientId: patientId, // state?.rowData?.patientId,
          personRxChangeId: eachItem?.rxChangeId,
          prescriberAgentId: doctorId,
          rxchangemedreqid: medRequestSelectedData[index]?.medicationRequestID, //medicationRequestID
          notes: values?.Notes,
          action: values?.actionType === "0" ? "" : values?.actionType,
          denialReason:
            values?.reasonDenied === "0" ? "" : values?.reasonDenied,
          selectedAddress: clinicId,
          substitutionCode: medRequestSelectedData[index]?.substitutionCode,
          pharmacyFaxNumber: eachItem?.pharmacyInformation?.fax,
          priorAuthorization: values?.paInformation,
        };
        const result = await RxChangeSendToPharmacy(bodyData);
        if (result?.data?.digitalRxStatusCode === 200) {
          setApprovedPopup(true);
          handleClickLoad(index);
          setSendToPharmacyData({
            ...result?.data?.response[0],
          });
          dispatch(loadingTopRibbon());
        } else {
          setSendToPharmacyData({});
          handleClickLoad(index);

          setDeleteStateData((prevState: any) => {
            return {
              ...prevState,
              message: result?.data?.digitalRxStatusMessage,
              variant: "error",
              open: true,
            };
          });
        }
      } catch (error) {
        setSendToPharmacyData({});
        handleClickLoad(index);

        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: "Something went wrong!",
            variant: "error",
            open: true,
          };
        });
      }
    }
  };

  return (
    <Box>
      {" "}
      <PendingRxChangeTab
        activeRxChangeTabClass={activeRxChangeTabClass}
        setActiveRxChangeTabClass={setActiveRxChangeTabClass}
      />
      <ContentStyle>
        {activeRxChangeTabClass ? (
          <PendingRxChangeAllergyInfo
            patientId={data[0]?.patientDetails?.patientId}
          />
        ) : (
          <>
            {loading ? (
              <Grid
                container
                justifyContent={"center"}
                alignItems={"center"}
                height={"100vh"}
              >
                <CircularProgress color="primary" />
              </Grid>
            ) : (
              <ScrollBarStyle
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }}
                className="full"
              >
                {data?.map((rxchange: any, index: number) => {
                  return (
                    <CommonCard
                      sx={{
                        backgroundColor: "#E3EBF0",
                        padding: "8px",
                      }}
                      key={index}
                    >
                      <RxChangePharmacyInfo
                        PharmaInfo={rxchange?.pharmacyInformation}
                      ></RxChangePharmacyInfo>
                      <MedPrescribeRequested
                        prescribedData={{
                          ...rxchange?.medicationPrescribed,
                          substitutionName:
                            rxchange?.medicationPrescribed?.substitutionCodeOptions?.find(
                              (sub: any) =>
                                sub?.id ===
                                rxchange?.medicationPrescribed?.substitutionCode
                            )?.name,
                        }}
                        requestedData={{
                          ...medRequestSelectedData[index],
                          substitutionName: medRequestSelectedData[
                            index
                          ]?.substitutionCodeOptions?.find(
                            (sub: any) =>
                              sub?.id ===
                              medRequestSelectedData[index]?.substitutionCode
                          )?.name,
                        }}
                        handleShowMedRequestPopupClick={
                          handleShowMedRequestPopupClick
                        }
                        setSelectedRxChange={setSelectedRxChange}
                        index={index}
                        rxchange={rxchange}
                      ></MedPrescribeRequested>
                      <Formik
                        initialValues={initialValues}
                        enableReinitialize
                        onSubmit={(values) => {
                          // prescriptionToSendPharmacy(rxchange, values, index);
                        }}
                      >
                        {(registerProps) => (
                          <Form onSubmit={registerProps.handleSubmit}>
                            <MedPrescribedForm
                              registerProps={registerProps}
                              reasonsOptions={rxchange?.reasonsOptions}
                              action={rxchange?.action?.map((option: any) => ({
                                label: option.label,
                                value: option.value,
                                disabled:
                                  option.label === "Approved"
                                    ? medRequestSelectedData[index]
                                        ?.scheduleDrug
                                    : false,
                              }))}
                              index={index}
                              prescriptionToSendPharmacy={
                                prescriptionToSendPharmacy
                              }
                              rxchange={rxchange}
                              load={load}
                              handleShowDeletePopupClick={
                                handleShowDeletePopupClick
                              }
                              setDeleteData={setDeleteData}
                            ></MedPrescribedForm>
                          </Form>
                        )}
                      </Formik>
                    </CommonCard>
                  );
                })}
              </ScrollBarStyle>
            )}
          </>
        )}
      </ContentStyle>
      <DialogPopup
        windowsize={"sm"}
        show={deletePharmacyPopup}
        handleShowPopupClick={handleShowDeletePopupClick}
        handleHidePopupClick={handleHideDeletePopupClick}
        close={true}
      >
        <ConfirmPopup
          deleteRowData={deleteRowData}
          handleHideDeletePopupClick={handleHideDeletePopupClick}
        />
      </DialogPopup>
      <DialogPopup
        title="Prescribed Status"
        windowsize={"sm"}
        show={ApprovedPopup}
        handleShowPopupClick={handleShowApprovedPopupClick}
        handleHidePopupClick={handleHideApprovedPopupClick}
      >
        <Grid
          container
          item
          xs={12}
          spacing={1}
          alignItems="top"
          justifyContent="center"
        >
          <Grid item xs={12} textAlign={"center"} marginTop={1}>
            {sendToPharmacyData?.statusCode === 0 && (
              <CheckCircleOutlineIcon
                style={{ height: 70, width: 70 }}
                color="success"
              />
            )}
            {sendToPharmacyData?.statusCode === 1 && (
              <img
                style={{ height: 40, width: 40 }}
                src={WarningIcon}
                alt="danger"
              />
            )}
            {sendToPharmacyData?.statusCode === 2 && (
              <HighlightOffIcon
                style={{ height: 40, width: 40, fill: "red" }}
              />
            )}
          </Grid>
          <Grid item xs={12} textAlign={"center"}>
            <Typography component="span" variant="subtitle2" fontWeight={600}>
              {sendToPharmacyData?.message}
            </Typography>{" "}
          </Grid>
        </Grid>{" "}
      </DialogPopup>
      <DialogPopup
        title="Medication Requested"
        windowsize={"sm"}
        show={MedRequestPopup}
        handleShowPopupClick={handleShowMedRequestPopupClick}
        handleHidePopupClick={handleHideMedRequestPopupClick}
      >
        <Typography
          variant="h1"
          fontSize={20}
          sx={{
            color: `${DRxTheme.palette.primary.main}`,
          }}
          marginBottom={2}
        >
          Medication Requested List(
          {data[selectedRxChange]?.medicationRequested?.length})
        </Typography>
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          {data[selectedRxChange]?.medicationRequested?.map((row: any) => {
            return (
              <>
                <AlternateMedications
                  row={row}
                  selectedRow={medRequestSelectedData?.find(
                    (data: any, index: number) =>
                      data?.drugID === row?.drugID && selectedRxChange === index
                  )}
                  selectedRxChange={selectedRxChange}
                  setMedRequestSelectedData={setMedRequestSelectedData}
                  handleHideMedRequestPopupClick={
                    handleHideMedRequestPopupClick
                  }
                />
              </>
            );
          })}
        </div>
      </DialogPopup>
      <YSSnackBar
        message={deleteStateData.message}
        variant={deleteStateData.variant}
        open={deleteStateData.open}
        handleClose={() => {
          setDeleteStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </Box>
  );
}

const MedPrescribeRequested = ({
  prescribedData,
  requestedData,
  handleShowMedRequestPopupClick,
  setSelectedRxChange,
  index,
  rxchange,
}: {
  prescribedData: any;
  requestedData: any;
  handleShowMedRequestPopupClick: any;
  setSelectedRxChange: any;
  index: number;
  rxchange: any;
}) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "stretch",
          marginBottom: 2,
        }}
      >
        <CommonCard className="Rx">
          <Box className="title">
            <img
              src={RxPrescribedIcon}
              alt="RX Change Request"
              loading="lazy"
              width="42px"
              height="42px"
            />
            <Typography variant="h6" fontSize={17} color="#0C585B">
              Rx Originally Prescribed
            </Typography>
            <Typography variant="caption" fontSize={14} color="#00000066">
              For Prescriber View
            </Typography>
          </Box>
          <Box className="content">
            <Typography component={"span"} variant={"body2"}>
              <strong>Written Date:</strong>
              <span>
                {prescribedData?.rxWrittenDate
                  ? prescribedData?.rxWrittenDate
                  : "N/A"}
              </span>
            </Typography>
            <Typography component={"span"} variant={"body2"}>
              <strong>Drug Name:</strong>
              <span>
                {prescribedData?.drugDescription
                  ? prescribedData?.drugDescription
                  : "N/A"}
              </span>
            </Typography>
            <Typography component={"span"} variant={"body2"}>
              <strong>SIG:</strong>
              <ExpandableText
                text={prescribedData?.sig}
                maxCharsReceived={90}
              />
            </Typography>
            <Box className="sl">
              <Typography component={"span"} variant={"body2"}>
                <strong>Quantity:</strong>
                <span>
                  {[null, ""].includes(prescribedData?.quantity) &&
                  [null, ""].includes(prescribedData?.quantityQualifer)
                    ? "N/A"
                    : `${prescribedData?.quantity ?? "N/A"}  ${
                        prescribedData?.quantity &&
                        prescribedData?.quantityQualifer
                          ? prescriptionForms[prescribedData?.quantityQualifer]
                          : ""
                      }`}
                </span>
              </Typography>
              <Typography component={"span"} variant={"body2"}>
                <strong>Days Supply:</strong>
                <span>
                  {prescribedData?.daysSupply
                    ? prescribedData?.daysSupply
                    : "N/A"}
                </span>
              </Typography>
              <Typography component={"span"} variant={"body2"}>
                <strong>Refills:</strong>
                <span>
                  {prescribedData?.refills || prescribedData?.refills === 0
                    ? prescribedData?.refills
                    : "N/A"}
                </span>
              </Typography>
            </Box>
            <Typography component={"span"} variant={"body2"}>
              <strong>Substitutions:</strong>
              <span>
                {prescribedData?.substitutionName
                  ? prescribedData?.substitutionName
                  : "N/A"}
              </span>
            </Typography>
          </Box>
        </CommonCard>
        <Box
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          flex={1}
        >
          <Box
            sx={{
              transform: { xs: "rotate(90deg)", md: "rotate(0deg)" },
            }}
            component="img"
            src={RxAlertsArrow}
            alt="Arrow"
          />
        </Box>
        <CommonCard className="RxChange">
          <Box className="title">
            <img
              src={RxRequestedIcon}
              alt="RX Change Request"
              loading="lazy"
              width="42px"
              height="42px"
            />
            <Typography variant="h6" fontSize={17} color="#0C585B">
              Rx Change requested from Pharmacy
            </Typography>
            <Typography variant="caption" fontSize={14} color="#000000cc">
              For Prescriber Action
            </Typography>
          </Box>
          <Box className="content">
            <Box className="pharmacyNote">
              <HtmlTooltip
                placement="top"
                arrow
                title={
                  requestedData?.pharmacyNote
                    ? requestedData?.pharmacyNote
                    : "Not Available"
                }
              >
                <img src={RxRequestedPharmaNote} alt="Pharmacy Note" />
              </HtmlTooltip>
            </Box>
            <Typography
              component={"span"}
              variant={"body2"}
              alignItems={"center"}
            >
              <strong>Requested Date:</strong>
              {requestedData?.rxWrittenDate
                ? requestedData?.rxWrittenDate
                : "N/A"}
              {rxchange?.type && (
                <HtmlTooltip
                  placement="top"
                  arrow
                  title={
                    drugTypes[rxchange?.type as keyof typeof drugTypes]
                      ?.description
                  }
                >
                  <Typography
                    bgcolor={"#fccf8b"}
                    component="div"
                    variant="body2"
                    borderRadius={5}
                    paddingX={1}
                    paddingY={0.5}
                    border={"1px solid orange"}
                  >
                    {drugTypes[rxchange?.type as keyof typeof drugTypes]?.title}
                  </Typography>
                </HtmlTooltip>
              )}
            </Typography>
            <Box className="sl">
              <Typography component={"span"} variant={"body2"}>
                <Typography component="span" variant="body2" minWidth="92px">
                  <strong>Drug Name:</strong>
                </Typography>

                <Typography
                  component="span"
                  variant="body2"
                  // flexDirection="column"
                  flexWrap="wrap"
                >
                  <span>
                    {" "}
                    {requestedData?.drugDescription
                      ? requestedData?.drugDescription
                      : "N/A"}
                    {requestedData?.deaClassCode && (
                      <span style={{ color: "#44799C", marginLeft: 4 }}>
                        {requestedData?.deaClassCode}
                      </span>
                    )}
                  </span>
                  {rxchange?.medicationRequested?.length > 1 && (
                    <Typography
                      component="span"
                      color="#44799C !important"
                      variant="body2"
                      sx={{
                        cursor: "pointer",
                        textDecoration: "underline",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        overflowWrap: "break-word",
                        maxWidth: "100%",
                      }}
                      onClick={() => {
                        setSelectedRxChange(index);
                        handleShowMedRequestPopupClick();
                      }}
                    >
                      Alternate Medications
                    </Typography>
                  )}
                </Typography>
              </Typography>{" "}
            </Box>
            <Typography component={"span"} variant={"body2"}>
              <strong>SIG:</strong>
              <ExpandableText
                text={requestedData?.sig}
                maxCharsReceived={110}
              />
            </Typography>
            <Box className="sl">
              <Typography component={"span"} variant={"body2"}>
                <strong>Quantity:</strong>
                <span>
                  {[null, ""].includes(requestedData?.quantity) &&
                  [null, ""].includes(requestedData?.quantityQualifer)
                    ? "N/A"
                    : `${requestedData?.quantity ?? "N/A"}  ${
                        requestedData?.quantity &&
                        requestedData?.quantityQualifer
                          ? prescriptionForms[requestedData?.quantityQualifer]
                          : ""
                      }`}
                </span>
              </Typography>
              <Typography component={"span"} variant={"body2"}>
                <strong>Days Supply:</strong>
                <span>
                  {requestedData?.daysSupply
                    ? requestedData?.daysSupply
                    : "N/A"}
                </span>
              </Typography>
              <Typography component={"span"} variant={"body2"}>
                <strong>Refills:</strong>
                <span>
                  {requestedData?.refills || requestedData?.refills === 0
                    ? requestedData?.refills
                    : "N/A"}
                </span>
              </Typography>
            </Box>
            <Typography component={"span"} variant={"body2"}>
              <strong>Substitutions:</strong>
              <span>
                {requestedData?.substitutionName
                  ? requestedData?.substitutionName
                  : "N/A"}
              </span>
            </Typography>{" "}
          </Box>
        </CommonCard>
      </Box>
    </>
  );
};
const MedPrescribedForm = ({
  registerProps,
  reasonsOptions,
  action,
  index,
  prescriptionToSendPharmacy,
  rxchange,
  load,
  handleShowDeletePopupClick,
  setDeleteData,
}: {
  registerProps: any;
  reasonsOptions: any;
  action: any;
  index: number;
  prescriptionToSendPharmacy: any;
  rxchange: any;
  load: any;
  handleShowDeletePopupClick: any;
  setDeleteData: any;
}) => {
  const isPorURef = useRef(false);
  const isPorU = () => {
    if (rxchange?.type === "P" || rxchange?.type === "U") {
      return true;
    }
    return false;
  };
  useEffect(() => {
    isPorURef.current = isPorU();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rxchange]);
  console.log("rxchange", action);
  return (
    <>
      <Grid container xs={12} md={12} spacing={1} alignItems={"flex-end"}>
        <Grid item xs={12} sm={12} md={5} lg={5}>
          <Typography component="label" variant="body2" htmlFor="note">
            Note
          </Typography>{" "}
          <DRxInputStyle style={{ marginTop: 5 }}>
            <DRxInput
              id="Notes"
              name={`rows[${index}].Notes`}
              className=""
              placeholder="Enter Note"
              // value={registerProps.values[index].Notes}
            />
          </DRxInputStyle>
        </Grid>
        {/* <Grid item xs={12} sm={12} md={6} lg={2}>
          <Typography
            component="label"
            variant="body2"
            htmlFor="dispensings"
            minWidth={"140px !important"}
            lineHeight={"normal"}
          >
            Total number of dispensings approved{" "}
          </Typography>
          <DRxInputStyle style={{ marginTop: 5 }}>
            <NumberInput
              name={`rows[${index}].refills`}
              min={0}
              max={99}
              step={1}
              registerProps={registerProps}
            />
          </DRxInputStyle>
        </Grid> */}
        <Grid item xs={12} sm={12} md={2} lg={2}>
          <Typography component="label" variant="body2" htmlFor="action">
            Action
          </Typography>

          <DRxSelectStyle style={{ marginTop: 5 }}>
            <DRxSelect
              id="actionType"
              name={`rows[${index}].actionType`}
              data={action}
              value={registerProps.values.actionType}
            />
          </DRxSelectStyle>
        </Grid>
        <Grid item xs={12} sm={12} md={5} lg={5}>
          <Typography component="label" variant="body2" htmlFor="reasonDenied">
            Denial Reason
          </Typography>
          <DRxSelectStyle style={{ marginTop: 5 }}>
            <DRxSelect
              id="reasonDenied"
              name={`rows[${index}].reasonDenied`}
              data={
                reasonsOptions?.length > 0
                  ? reasonsOptions
                  : [
                      {
                        label: "--Select Reason--",
                        value: "0",
                        disabled: false,
                      },
                    ]
              }
              // value={registerProps.values[index].reasonDenied}
            />
          </DRxSelectStyle>
        </Grid>
      </Grid>
      <Grid
        container
        xs={12}
        md={12}
        spacing={1}
        alignItems={"flex-end"}
        style={{ marginTop: 5 }}
      >
        {isPorURef.current && (
          <Grid item xs={12} sm={12} md={5} lg={5}>
            <Typography component="label" variant="body2" htmlFor="note">
              PA Information
            </Typography>{" "}
            <DRxInputStyle>
              <DRxInput
                id="Notes"
                name={`rows[${index}].paInformation`}
                className=""
                placeholder="Enter PA Information"
              />
            </DRxInputStyle>
          </Grid>
        )}

        <Grid
          item
          xs={12}
          md={isPorURef.current ? 7 : 12}
          lg={isPorURef.current ? 7 : 12}
        >
          <BtnGroupStyle className="right">
            {" "}
            <YSButton
              size={"medium"}
              type="submit"
              color="primary"
              variant="contained"
              children={
                load[index] ? (
                  <CircularProgress color="inherit" size={28} />
                ) : (
                  "Send to Pharmacy"
                )
              }
              onClick={() => {
                prescriptionToSendPharmacy(
                  rxchange,
                  registerProps?.values?.rows[index],
                  index
                );
              }}
              startIcon={
                <img
                  src={SendPharmacyIcon}
                  alt="Send to Pharmacy"
                  loading="lazy"
                />
              }
            />
            <BtnIconStyle>
              <Tooltip title="Delete">
                <IconButton
                  onClick={() => {
                    handleShowDeletePopupClick();
                    setDeleteData(rxchange?.rxChangeId);
                    // rxChangeMedicationRequestId
                  }}
                  type="button"
                  className="trash"
                >
                  <img src={TrashIcon} alt="Delete" loading="lazy" />
                </IconButton>
              </Tooltip>
            </BtnIconStyle>
          </BtnGroupStyle>
        </Grid>
      </Grid>
    </>
  );
};

interface AlternateMedProps {
  row: any;
  selectedRxChange: any;
  selectedRow: any;
  setMedRequestSelectedData: any;
  handleHideMedRequestPopupClick: any;
}
const AlternateMedications = (props: AlternateMedProps) => {
  const {
    row,
    selectedRxChange,
    selectedRow,
    setMedRequestSelectedData,
    handleHideMedRequestPopupClick,
  } = props;

  return (
    <>
      <RxChangeRequestedCard sx={{ padding: "16px !important" }}>
        <Grid container>
          <Grid item xs={3} md={3}>
            <Typography component={"span"} variant={"body2"}>
              <strong>Drug Name</strong>
            </Typography>
          </Grid>
          <Grid item xs={8} md={8}>
            <Typography component={"span"} variant={"body2"}>
              {": "}
              {row.drugDescription ? row.drugDescription : "N/A"}
            </Typography>
          </Grid>
          <Grid
            item
            xs={1}
            md={1}
            display={"flex"}
            justifyContent={"flex-end"}
            sx={{
              cursor: "pointer",
            }}
          >
            {selectedRow?.medicationRequestID !== row?.medicationRequestID ? (
              <CircleOutlinedIcon
                sx={{
                  color: `${DRxTheme.palette.primary.main}`,
                }}
                onClick={() => {
                  // rxchangeMedicationRequest(medReqData?.rxChangeId);
                  setMedRequestSelectedData((prevData: any) =>
                    prevData.map((item: any, idx: number) =>
                      idx === selectedRxChange ? { ...item, ...row } : item
                    )
                  );
                  handleHideMedRequestPopupClick();
                }}
              />
            ) : (
              <CheckCircleIcon
                sx={{
                  color: `${DRxTheme.palette.primary.main}`,
                  // color: "#0C585B"
                }}
              />
            )}
          </Grid>
          <Grid item xs={3} md={3}>
            <Typography component={"span"} variant={"body2"}>
              <strong>SIG</strong>
            </Typography>
          </Grid>
          <Grid item xs={9} md={9}>
            <Typography
              component={"span"}
              variant={"body2"}
              sx={{
                wordBreak: "break-all",
              }}
            >
              {": "}
              {row.sig ? row?.sig : "N/A"}
            </Typography>
          </Grid>
          <Grid item xs={3} md={3}>
            <Typography component={"span"} variant={"body2"}>
              <strong>Quantity</strong>
            </Typography>
          </Grid>
          <Grid item xs={3} md={3}>
            <Typography component={"span"} variant={"body2"}>
              {": "}
              {[null, ""].includes(row?.quantity) &&
              [null, ""].includes(row?.qtyQualifier)
                ? "N/A"
                : `${row?.quantity ?? "N/A"}  ${
                    row?.quantity && row?.quantityQualifer
                      ? prescriptionForms[row?.quantityQualifer]
                      : ""
                  }`}
            </Typography>
          </Grid>
          <Grid item xs={2} md={2}>
            <Typography component={"span"} variant={"body2"}>
              <strong>Refiils</strong>
            </Typography>
          </Grid>
          <Grid item xs={3} md={3}>
            <Typography component={"span"} variant={"body2"}>
              {": "}
              {row.refills ? row.refills : "N/A"}
            </Typography>
          </Grid>
          <Grid item xs={3} md={3}>
            <Typography component={"span"} variant={"body2"}>
              <strong>Substitution</strong>
            </Typography>
          </Grid>
          <Grid item xs={9} md={9}>
            <Typography component={"span"} variant={"body2"}>
              {": "}
              {row.substitutionName ? row.substitutionName : "N/A"}
            </Typography>
          </Grid>
          <Grid item xs={3} md={3}>
            <Typography component={"span"} variant={"body2"}>
              <strong>Notes</strong>
            </Typography>
          </Grid>
          <Grid item xs={9} md={9}>
            <Typography component={"span"} variant={"body2"}>
              {": "}
              {row.pharmacyNote ? row.pharmacyNote : "N/A"}
            </Typography>
          </Grid>
        </Grid>
      </RxChangeRequestedCard>
    </>
  );
};
